import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as IntegrationEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor";
import { Route as IntegrationGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/"
)({
    component: IntegrationDetailPage,
    staticData: {
        permissions: [
            PermissionEnum.ToolIntegrationEditor,
            PermissionEnum.ToolIntegrationGeneral,
        ],
        showInSideMenu: false,
        label: "pages.tool.scenario.integration.detail.title",
        redirects: [IntegrationGeneralPage, IntegrationEditorPage],
        defaultRedirect: IntegrationGeneralPage,
    },
});

function IntegrationDetailPage() {
    return <RedirectPage />;
}
